<div class="relative flex flex-col gap-5 p-6 md:p-8 w-full max-w-md">
    <!-- Close icon -->
    <button
        type="button"
        class="absolute top-3 right-3 inline-flex items-center justify-center w-8 h-8 rounded-full text-secondary hover:bg-gray-100 hover:text-gray-900 transition-colors"
        (click)="close()"
        [attr.aria-label]="'Close' | transloco"
    >
        <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
    </button>

    <!-- Header -->
    <div class="flex items-center gap-2 text-primary">
        <mat-icon class="icon-size-6" [svgIcon]="'heroicons_outline:megaphone'"></mat-icon>
        <span class="text-sm font-semibold uppercase tracking-wide">
            {{ "What's new in the platform" | transloco }}
        </span>
    </div>

    <!-- Release meta -->
    <div class="flex flex-col gap-2">
        <div class="flex items-center gap-2">
            <ac-badge color="primary">{{ release.version }}</ac-badge>
            <span class="inline-flex items-center gap-1 text-sm text-secondary">
                <mat-icon class="icon-size-4" [svgIcon]="'heroicons_outline:calendar-days'"></mat-icon>
                {{ release.publishedAt | date: "dd/MM/yyyy" }}
            </span>
        </div>
        <h2 class="text-xl font-bold text-gray-900 leading-tight m-0">{{ release.title }}</h2>
        <p class="text-sm text-secondary leading-relaxed m-0">{{ release.summary }}</p>
    </div>

    <!-- Highlights -->
    <ul *ngIf="highlights.length" class="flex flex-col gap-2 m-0 p-0 list-none">
        <li
            *ngFor="let h of highlights; trackBy: trackByHighlight"
            class="flex items-center gap-3 p-3 rounded-lg bg-gray-50 border"
        >
            <span
                class="inline-flex items-center justify-center w-8 h-8 rounded-full"
                [class.bg-primary-50]="h.category === 'feature'"
                [class.text-primary]="h.category === 'feature'"
                [class.bg-blue-50]="h.category === 'improvement'"
                [class.text-tertiary]="h.category === 'improvement'"
                [class.bg-amber-50]="h.category === 'fix'"
                [class.text-amber-700]="h.category === 'fix'"
            >
                <mat-icon class="icon-size-4" [svgIcon]="categoryIcon(h.category)"></mat-icon>
            </span>
            <div class="flex items-baseline gap-1.5">
                <span class="text-base font-semibold text-gray-900">{{ h.count }}</span>
                <span class="text-sm text-gray-700">{{ categoryLabel(h.category) | transloco }}</span>
            </div>
        </li>
    </ul>

    <!-- Actions -->
    <div class="flex items-center justify-end gap-2 pt-2 border-t">
        <ac-button type="text" color="dark" (clicked)="skip()">
            {{ "Skip for now" | transloco }}
        </ac-button>
        <ac-button type="raised" color="primary" (clicked)="openChangelog()">
            {{ "View all updates" | transloco }}
            <mat-icon class="icon-size-4 ml-1" [svgIcon]="'heroicons_outline:arrow-right'"></mat-icon>
        </ac-button>
    </div>
</div>
